import {
  SCHOOL_DATA_CONSTANTS,
  GOOD_SYSTEM_BUILD_VERSION,
  NEW_SD_CARD_VERSION_AY,
  SD_CARD_PROFILE_NAME,
} from "../constants/schoolData";
import moment from "moment";
export const checkLastAction = (data) => {
  if (data.triggeredFrom === SCHOOL_DATA_CONSTANTS.actions.persistence) {
    return 1;
  }
  if (data.triggeredFrom === SCHOOL_DATA_CONSTANTS.actions.click) {
    return 0;
  }
  return 2;
};

export const checkVersion = (data) => {
  if (data.buildNumber && data.buildNumber >= 432) {
    return 0;
  }
  if (data.buildNumber === 432) {
    return 1;
  }
  return 2;
};

// check if the mdmid is present then return 0, else 1
export const checkMDMState = (data) => {
  if (data.mdmDeviceId && data.mdmDeviceId !== "nan") {
    return 0;
  }
  return 1;
};

export const checkResources = (data) => {
  // if (data.redResources < 10 && data.totalResources > 1000) {
  //   return 0;
  // }
  // if (data.teacherRedResources < 20 && data.teacherTotalResources > 100) {
  //   return 0;
  // }
  // if (data.teacherRedResources < 50 && data.teacherTotalResources > 500) {
  //   return 1;
  // }
  // if (data.redResources < 100 && data.totalResources > 1000) {
  //   return 1;
  // }
  // return 2;

  if (typeof data.teacherRedResources != "number") return 2;

  if (data.teacherRedResources <= 55) {
    return 0;
  } else if (
    data.teacherRedResources > 55 &&
    data.teacherTotalResources > 0 &&
    data.teacherRedResources / data.teacherTotalResources > 0.95
  ) {
    return 1;
  } else {
    return 2;
  }
};

export const checkNasStatus = (data) => {
  // if (("" + data.wifiName).toLowerCase().replace(/\"/g, "") == "lead ap") {
  //   return 0;
  // }
  if (
    (data.lastNasIp !== null && data.lastNasIp !== "") ||
    (data.isNasEnabled &&
      data.isNasEnabled !== "nan" &&
      data.isNasEnabled !== "false")
  ) {
    return 0;
  }
  return 1;
};

export const humanizeBytes = (size) => {
  return bytesToGB(size) + " GB";
};

export function bytesToGB(bytes) {
  const gigabytes = bytes / (1024 * 1024 * 1024);
  return Math.ceil(gigabytes * 10) / 10;
}

export const getNasPercentage = (nasStatus) => {
  let percent = 0;
  const contentDownloaded = nasStatus ? Number(nasStatus.contentDownloaded) : 0;
  const s3Count = nasStatus ? Number(nasStatus.s3_count) : 0;

  if (!isNaN(contentDownloaded) && !isNaN(s3Count) && s3Count > 0) {
    percent = ((contentDownloaded / s3Count) * 100).toFixed(1);

    if (percent > 100) return 100;
  }
  return percent;
};

export const getDaysDifference = (date1, date2) => {
  // Parse the dates using Moment.js
  const momentDate1 = moment(date1, "ddd MMM DD HH:mm:ss [GMT]ZZ YYYY");
  const momentDate2 = moment(date2, "ddd MMM DD HH:mm:ss [GMT]ZZ YYYY");

  // Calculate the difference in days
  const daysDifference = momentDate2.diff(momentDate1, "days");

  if (isNaN(daysDifference)) return -1;

  return daysDifference;
};

export const getSDCardErrorMessage = (sdCardErrorMessage) => {
  if (sdCardErrorMessage && sdCardErrorMessage !== "nan") {
    return sdCardErrorMessage;
  } else {
    return null;
  }
};

export const checkSDCardErrorState = (data) => {
  // Check if academicYear meets the minimum requirement
  if (data?.academicYear >= NEW_SD_CARD_VERSION_AY) {
    const sbCardOrbiterIds = Object.keys(SD_CARD_PROFILE_NAME);
    if (data?.sdCardVersion && sbCardOrbiterIds.some(version => data.sdCardVersion.startsWith(version))) {
      return 0;
    } else {
      return 1;
    }
  } else {
    // Check if sdCardErrorMessage exist for schools in AY less than 8
    if (getSDCardErrorMessage(data?.sdCardErrorMessage)) {
      return 1;
    } else {
      return 0;
    }
  }
};

export const checkSystemBuildVersionState = (data) => {
  if (GOOD_SYSTEM_BUILD_VERSION.includes(data.systemBuildVersion)) {
    return 0;
  } else {
    return 2;
  }
};

export const getExpectedSystemBuildVersion = (systemBuildVersion) => {
  if (systemBuildVersion && systemBuildVersion.length > 4) {
    const inputParts = systemBuildVersion.split("_");
    const inputModel = inputParts[0];
    const inputDate = inputParts[2];

    const matchingVersions = GOOD_SYSTEM_BUILD_VERSION.filter((version) =>
      version.startsWith(inputModel)
    );

    if (matchingVersions.length > 0) {
      const greaterVersions = matchingVersions.filter((version) => {
        const parts = version.split("_");
        const model = parts[0];
        const date = parts[2];

        return model === inputModel && date > inputDate;
      });

      const formattedVersions = greaterVersions.map((version) => {
        const inputParts = version.split("_");
        const inputModel = inputParts[0];
        const inputRelease = inputParts[1];
        const inputDate = inputParts[2];
        const inputFileFormat = inputParts[3];

        return (
          `${inputModel}_${inputRelease}_` +
          `<strong>${inputDate}</strong>` +
          `_${inputFileFormat}<br>`
        );
      });

      return formattedVersions[0];
    } else {
      return null; // Model not found in the list
    }
  } else {
    return null;
  }
};

export const getDateIfValid = (date) => (date && date.length > 3 ? date : null);

export const isDateBefore = (date1, date2) =>
  date1 && moment(date1).isBefore(moment(date2));
